import { FC, useMemo } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuiz } from 'store/quiz/quizzesSelectors';
import { getQuizAnalytics } from 'store/result/resultSelectors';
// Types
import QuizTypes from 'types/QuizTypes';
// Models
import IQuiz from 'models/Quiz';
// i18next
import { useTranslation } from 'react-i18next';
//
import ReactApexChart from "react-apexcharts";
import IAnalytics from 'models/QuizAnalytics';

const SocialsBars:FC = () => {
  const { t } = useTranslation();

  const analytics = useAppSelector(getQuizAnalytics);
  const quiz:IQuiz | null = useAppSelector(selectQuiz);

  const shareClicks = useMemo(() => {
    if (!analytics) return {};
    return {
      'Facebook': socialShareClicks(analytics, 'facebook'),
      'X': socialShareClicks(analytics, 'twitter'),
      'LinkedIn': socialShareClicks(analytics, 'linkedIn'),
      'Messenger': socialShareClicks(analytics, 'messenger'),
      'WhatsApp': socialShareClicks(analytics, 'whatsApp'),
      'Threads': socialShareClicks(analytics, 'threads'),
    }
  }, [analytics])

  const socialShares = analytics?.socialShares || [];
  const totalClicks = socialShares.reduce((acc, cur) => acc + cur.shares, 0);

  const series = [{
    name: 'Share clicks',
    data: Object.values(shareClicks)
  }];

  const options:any = {
    chart: {
      type: 'bar',
      height: 250,
      width: 600,
      background: '#23272a'
    },
    colors: '#ff9000',
    plotOptions: {
      bar: {
        borderRadius: 4,
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true
    },
    xaxis: {
      categories: Object.keys(shareClicks),
      labels: {
        style: {
          colors: '#eee'
        }
      }
    },
    yaxis: {
      labels: {
        show: false
      }
    }
  }

  if ( !analytics ) return null;
  if ( !quiz || quiz.type === QuizTypes.Personality ) return null;
  return (
    <div className="mb-8">
      <h3 className="text-white font-bold">{t('pages.quizAnalytics.socialsShareClicksLabel')}</h3>
      <p className="text-white text-sm font-light text-opacity-80">{`${t('pages.quizAnalytics.totalLabel')}: ${totalClicks}`}</p>
      <ReactApexChart options={options} series={series} type="bar" height={250} width={600} />
    </div>
  )
}

export default SocialsBars;

const socialShareClicks = (analytics:IAnalytics, type:string) => {
  if ( !analytics || !analytics.socialShares ) return 0;
  const findedType = analytics.socialShares.find((share) => share.type === type);
  if ( !findedType ) return 0;
  return findedType.shares;
}
